import React, { PureComponent } from 'react';
import injectSheet from 'react-jss'
import SearchSummary from './SearchSummary'
import SearchList from './SearchList'

class Search extends PureComponent {

    render() {
        if(this.props.type === 'summary') return <SearchSummary />
        return <SearchList />
    }
}

export default injectSheet((theme) => ({
}))( Search );



// WEBPACK FOOTER //
// ./src/components/Search/index.js